/* eslint no-unused-vars: off, @typescript-eslint/no-unused-vars: off */
import { Logger, LogTypes } from 'Common/appshell_types/loggerTypes';

class SilentLogger implements Logger {
    private static instance: SilentLogger;

    public static createInstance(): SilentLogger {
        if (!SilentLogger.instance) {
            SilentLogger.instance = new SilentLogger();
        }
        return SilentLogger.instance;
    }

    public log(logType: LogTypes, entry: string | Error, customData: Object = {}): void {}

    public debug(message: string, customData?: Object): void {}

    public info(message: string, customData?: Object): void {}

    public warn(message: string, customData?: Object): void {}

    public error(error: string | Error, customData?: Object): void {}
}

export default SilentLogger;
